import React from "react";

import { Close as CloseIcon, Search as SearchIcon } from "@mui/icons-material";
import { Avatar, Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { SearchAppointmentListItemFragment } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

type SelectedAppointmentViewProps = {
  onClose: () => void;
  searchDocument: SearchAppointmentListItemFragment | null;
};

const useStyles = makeStyles()({
  container: {
    height: 52,
    display: "flex",
    alignItems: "center",
    paddingLeft: 13,
    paddingRight: 13,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#D4DBE5",
  },
  user: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    marginLeft: 10,
  },
  avatar: {
    width: 30,
    height: 30,
    borderRadius: 50,
  },
  infoContainer: {
    marginLeft: 10,
  },
  name: {
    fontSize: 14,
    fontWeight: 600,
  },
  email: {
    fontSize: 12,
    color: colors.grey,
  },
  close: {
    cursor: "pointer",
  },
});

const SelectedAppointmentView: React.FC<SelectedAppointmentViewProps> = ({
  onClose,
  searchDocument,
}) => {
  const { classes } = useStyles();

  const _avatarUrl = (): string => {
    switch (searchDocument?.searchable.__typename) {
      case "Appointment":
        return searchDocument?.searchable["client"].profile?.avatar?.url ?? "";
      case "Account":
        return searchDocument?.searchable["owner"].profile?.avatar?.url ?? "";
      case "Profile":
        return searchDocument?.searchable["avatar"].url;

      default:
        return "";
    }
  };

  const _fullName = (): string => {
    switch (searchDocument?.searchable.__typename) {
      case "Appointment":
        return searchDocument?.searchable["client"].profile?.fullName ?? "N/A";
      case "Account":
        return searchDocument?.searchable["owner"].profile?.fullName ?? "N/A";
      case "Profile":
        return searchDocument?.searchable["fullName"];
      default:
        return "N/A";
    }
  };

  const _email = (): string => {
    switch (searchDocument?.searchable.__typename) {
      case "Appointment":
        return searchDocument?.searchable["client"].profile?.fullName ?? "N/A";
      case "Account":
        return searchDocument?.searchable["email"];
      case "Profile":
        return searchDocument?.searchable["fullName"];
      default:
        return "avatar";
    }
  };

  return (
    <Box className={classes.container}>
      <SearchIcon htmlColor={colors.grey} />
      <Box className={classes.user}>
        <Avatar src={_avatarUrl()} alt={_fullName()} />
        <Box className={classes.infoContainer}>
          <Typography className={classes.name}>{_fullName()}</Typography>
          <Typography className={classes.email}>{_email()}</Typography>
        </Box>
      </Box>
      <CloseIcon className={classes.close} onClick={onClose} />
    </Box>
  );
};

export default SelectedAppointmentView;
